module.exports = __webpack_public_path__ + "static/img/c1.3c37c5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/szr/c1.png
// module id = qBGw
// module chunks = 0